import api from "../../../lib/axios";
import { apiUtils } from "../../../utils/apiUtils";
import type {
  Category,
  CategoryListParams,
  CategoryListResponse,
  CategoryPayload,
} from "../types/category.types";

const endpoint = "/v1/portal/category";

export function getCategories(params: CategoryListParams, signal?: AbortSignal) {
  return apiUtils.getData<CategoryListResponse>(endpoint, "Failed to load categories", {
    params,
    signal,
  });
}

export function getCategory(id: string) {
  return apiUtils.getData<Category>(`${endpoint}/${id}`, "Failed to load category");
}

export async function createCategory(payload: CategoryPayload) {
  const formData = new FormData();
  formData.append("name", payload.name);
  formData.append("type", payload.type);
  if (payload.image) formData.append("image", payload.image);
  return apiUtils.unwrap(
    await apiUtils.postWithFormData<Category>(endpoint, formData),
    "Failed to create category",
  );
}

export async function updateCategory(id: string, payload: CategoryPayload) {
  const formData = new FormData();
  formData.append("name", payload.name);
  formData.append("type", payload.type);
  if (payload.image) formData.append("image", payload.image);
  return apiUtils.unwrap(
    await apiUtils.putWithFormData<Category>(`${endpoint}/${id}`, formData),
    "Failed to update category",
  );
}

export async function deleteCategory(id: string) {
  await api.delete(`${endpoint}/${id}`);
}
